<div class="h-full w-full p-[2%]">
    <div class="grid grid-cols-2">
        <div class="window-name">
            Edit SLA Days       
        </div>
        <div class="grid justify-end">
            <mat-icon [svgIcon]="'custom:close'" class="pointer " (click)="onCloseBtnClick()"></mat-icon>
        </div>
    </div>

    <hr class="relative top-[1vh]">

    <div class="relative top-[2vh] pt-[2vh] search-bar" >
          <input matInput  type="text" (input)="onSearchFilter($event.target.value)" id="searchLocation3" [placeholder]="dashboardService.translate('Search use-cases')">       
          <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
    </div>

    <hr class="relative top-[3vh]">

    <div class="relative grid grid-cols-3 pt-[5vh]">
        <div>
            <div class="heading">
                Departments
            </div>
            <div class="h-[40vh] overflow-x-hidden w-full relative top-[0.5vh]">
                <div class="relative pt-[1vh] department-placement" style="cursor: pointer !important;" (click)="onAssetClick(assetType)"
                 [ngClass]="selectedAssetType && assetType && selectedAssetType.department_name ==assetType.department_name? 'department-selected':''" 
                *ngFor="let assetType of filters">
                    <div class="department-name pt-[0.5vh]" style="cursor: pointer !important;" >
                        {{dashboardService.translate(assetType.department_name.replaceAll('_','')) | titlecase}}
                    </div>
                </div>
            </div>
        </div>
        <div class="verticalLine relative bottom-[1.7vh] left-[4vw]"></div> 
        <div class="relative right-[6vw] w-[23vw] ">
            <div class="relative right-[2vh] w-full h-full">
                <div class="grid grid-cols-2">
                    <div class="heading">
                        Use-Cases
                    </div>
                    <div class="heading relative left-[2vw]">
                        SLA Days
                    </div>
                </div>
                <div class="relative top-[1vh]">
                    <mat-checkbox class="" (change)="onSelectAllAssetsClick($event.checked)">
                        {{dashboardService.translate('Select All')}}
                    </mat-checkbox>
                </div>
                <div class="h-[38vh] overflow-x-hidden w-full top-[1vh] right-[1vw] relative">
                    <mat-checkbox class="py-2 pl-5 w-[100%] " [checked]="isChecked(asset)" (change)="onSelectFilterChange(asset,$event)" style="height: 31px !important;"
                    *ngFor="let asset of selectedAssetType.assets">
                    <div class="grid grid-cols-2">
                        <div class="w-[20vw]">
                            {{asset.asset_name ? asset.asset_name.replaceAll('_',' ') : ''}} 
                        </div>
                        <div class="grid justify-end relative right-[1vw]">
                            {{asset.sla_days}}
                        </div>
                    </div>
                    </mat-checkbox>
                </div>                    
            </div>
        </div>
    </div>
    <hr class="relative w-full top-[2vh]">
    <div class="grid grid-cols-2 relative pt-[4vh]">
        <div class="grid grid-cols-2">
            <div class="justify-center grid relative top-[2vh]" style="color: var(--heading, #31384B);
            font-family: 'Inter var';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;" >
                Enter New SLA Days :  
            </div>
            <div class="justify-start grid input-text">
                <input matInput type="number" pattern="[0-9]*" (input)="numberOFDaysEntered($event.target.value)" 
                [placeholder]="dashboardService.translate('Enter number')">
            </div>
        </div>
        <div class="grid justify-end h-full w-full">
            <button id="saveBtnEnable" class="flex flex-col moveBtn h-full w-full hover:shadow-lg  disabled:opacity-50" [disabled]="saveBtnEnable" (click)="saveChanges()">
                <p class="btnText text-lg font-bold relative pointer" >
                    Save Changes 
                </p>
            </button>
        </div>
    </div>
</div>